import React from 'react'
import clsx from 'clsx'
import { Box, Button, Icon, Tooltip } from '@node-space/ui-components'

export const EarnSummaryItemVariant = {
  DEFAULT: 'default',
  LARGE: 'large',
} as const

export type EarnSummaryItemVariant =
  (typeof EarnSummaryItemVariant)[keyof typeof EarnSummaryItemVariant]

export interface EarnSummaryItemProps {
  label: string
  value: string
  variant?: EarnSummaryItemVariant
  tooltipContent?: string
}

export const EarnSummaryItem = ({
  label,
  value,
  variant = EarnSummaryItemVariant.DEFAULT,
  tooltipContent,
}: EarnSummaryItemProps) => {
  const isLarge = variant === EarnSummaryItemVariant.LARGE

  return (
    <Box flexCol justify="center" gap={4} className="flex-1 min-w-0">
      <Box flex align="center" gap={8}>
        <p className="text-label text-foreground-prominent">{label}</p>
        {tooltipContent && (
          <Tooltip bodyContent={tooltipContent} type="simple" position="bottom">
            <Button variant="ghost" iconElement={<Icon name="Info" />} />
          </Tooltip>
        )}
      </Box>
      <p
        className={clsx('text-foreground-prominent', {
          'text-h1': isLarge,
          'text-h3': !isLarge,
        })}
      >
        {value}
      </p>
    </Box>
  )
}
